import {
  ComponentPropsWithoutRef,
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { range as formRange } from '../../form/field/range-input';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;
type FormRangeProps = ComponentPropsWithoutRef<typeof formRange>;

type Props = FormRangeProps;

export const range: FR<HTMLDivElement, Props> = forwardRef((props, ref) => {
  const FormRange = formRange;

  return <FormRange {...props} ref={ref} />;
});

range.displayName = 'SiloReal-Filter-Field-Range';

export type { RangeInputValue } from '../../form/field/range-input';
